import region from '../../../utils/region.js'
import {HMAO, KALUG, KAREL, KRASN, KURGAN, ORENB, SAAS, TATAR, YANAO, BURYATIA, MARIEL, KURSK, PSCOV} from '../../../config/region.js'
import MENU_HMAO from "./region.hmao"
import MENU_KRASN from "./region.krasn"
import MENU_DEFAULT from "./region.default"
import MENU_ORENB from "./region.orenb"
import MENU_KALUG from "./region.kalug"
import MENU_SAAS from "./region.saas"
import MENU_KAREL from "./region.karel"
import MENU_KURGAN from "./region.kurgan"
import MENU_TATAR from "./region.tatar"
import MENU_YANAO from "./region.yanao";
import MENU_BURYATIA from "./region.buryatia";
import MENU_MARIEL from "./region.mariel"
import MENU_KURSK from "./region.kursk"
import MENU_PSCOV from "./region.pscov"

let _MENU_ITEMS = {
  default: MENU_DEFAULT,
  [HMAO]: MENU_HMAO,
  [KRASN]: MENU_KRASN,
  [ORENB]: MENU_ORENB,
  [KALUG]: MENU_KALUG,
  [SAAS]: MENU_SAAS,
  [KAREL]: MENU_KAREL,
  [KURGAN]: MENU_KURGAN,
  [MARIEL]: MENU_MARIEL,
  [TATAR]: MENU_TATAR,
  [YANAO]: MENU_YANAO,
  [BURYATIA]: MENU_BURYATIA,
  [KURSK]: MENU_KURSK,
  [PSCOV]: MENU_PSCOV
}

export const MENU_ITEMS = region.getRegionConfig(_MENU_ITEMS)
